<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px" scrollable>
    <v-card>
      <v-card-title>
        <span class="text-h5">新增帳號</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text style="max-height: 500px;">
        <v-form ref="form" v-model="formValid">
          <!-- 名稱 -->
          <v-text-field
            v-model="form.name"
            :rules="[rules.required]"
            required
            outlined
            dense
          >
            <template v-slot:label>
              名稱 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- 帳號 -->
          <v-text-field
            v-model="form.account"
            hint="建議使用手機號碼，不可與其他帳號重複"
            persistent-hint
            :rules="[rules.required]"
            required
            outlined
            dense
          >
            <template v-slot:label>
              帳號 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- 登入密碼 -->
          <v-text-field
            v-model="form.password"
            :rules="[rules.required]"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            autocomplete="new-password"
            required
            outlined
            dense
          >
            <template v-slot:label>
              登入密碼 <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- Email -->
          <v-text-field
            v-model="form.email"
            :rules="[rules.required, rules.email]"
            autocomplete="off"
            required
            outlined
            dense
          >
            <template v-slot:label>
              Email <span class="red--text">*</span>
            </template>
          </v-text-field>

          <!-- 帳號權限 -->
          <v-card outlined class="mt-4">
            <v-card-title class="text-subtitle-1 py-2">
              {{ isCopyMode ? '欲複製的帳號權限' : '帳號權限' }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="max-height: 300px; overflow-y: auto;">
              <AccountPermissionSelector
                v-model="form.permissions"
                :availablePermissions="availablePermissions"
                @open-page="handleOpenPage"
              />
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">
          取消
        </v-btn>
        <v-btn
          color="teal"
          :dark="formValid"
          :disabled="!formValid"
          @click="handleSubmit"
        >
          送出
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AccountPermissionSelector from './AccountPermissionSelector.vue'

/**
 * AccountCreateDialog - 新增帳號 Dialog
 *
 * Props:
 * - value: Dialog 開關狀態（v-model）
 * - availablePermissions: 可用權限列表
 * - initialPermissions: 初始權限（用於複製模式）
 * - isCopyMode: 是否為複製模式
 *
 * Events:
 * - input: Dialog 開關變更
 * - submit: 提交表單
 */
export default {
  name: 'AccountCreateDialog',
  components: {
    AccountPermissionSelector
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    availablePermissions: {
      type: Array,
      default: () => []
    },
    initialPermissions: {
      type: Array,
      default: null
    },
    isCopyMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formValid: false,
      showPassword: false,  // 控制密碼顯示/隱藏
      form: {
        name: '',
        account: '',
        password: '',
        email: '',
        permissions: []
      },
      rules: {
        required: v => !!v || '此欄位為必填',
        email: v => /.+@.+\..+/.test(v) || '請輸入正確的 Email 格式'
      }
    }
  },
  watch: {
    // 當 Dialog 打開時，重置表單
    value(newVal) {
      if (newVal) {
        this.resetForm()
      }
    },
    // 當 initialPermissions 變更時，更新權限
    initialPermissions: {
      handler(newVal) {
        if (newVal) {
          this.form.permissions = [...newVal]
        } else {
          // 預設全選
          this.form.permissions = this.availablePermissions.map(p => p.code_name)
        }
      },
      immediate: true
    }
  },
  methods: {
    resetForm() {
      this.form = {
        name: '',
        account: '',
        password: '',
        email: '',
        permissions: this.initialPermissions
          ? [...this.initialPermissions]
          : this.availablePermissions.map(p => p.code_name) // 預設全選
      }

      // 重置驗證
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    handleOpenPage(permissionCode) {
      const route = this.$router.resolve({ name: permissionCode })
      if (route && route.href) {
        window.open(route.href, '_blank')
      }
    },
    handleSubmit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$emit('submit', { ...this.form })
    }
  }
}
</script>
